import React from "react";
import { Link } from "@tanstack/react-router";
import CsLineIcons from "cs-line-icons/CsLineIcons";

const SidebarMenuItems = React.memo(({ menuItems = [] }) =>
  menuItems.map((item, index) => (
    <SidebarMenuItem
      key={`menu.${item.path}.${index}`}
      id={item.path}
      item={item}
    />
  ))
);
SidebarMenuItems.displayName = "SidebarMenuItems";

const SidebarMenuItem = ({ item, id }) => {
  const getLabel = (icon, label) => (
    <>
      {icon && (
        <>
          <CsLineIcons icon={icon} className="cs-icon icon" />{" "}
        </>
      )}
      <span className="label">{label}</span>
    </>
  );

  if (item.subs) {
    return (
      <li>
        <Link
          to={item.path}
          className={"cat"}
          activeOptions={{
            exact: true,
            includeSearch: false,
          }}
          activeProps={{
            className: "active",
          }}
          data-bs-target={item.path}
        >
          {getLabel(item.icon, item.label)}
        </Link>
        <ul>
          <SidebarMenuItems menuItems={item.subs} />
        </ul>
      </li>
    );
  }
  if (item.isExternal) {
    return (
      <li key={id}>
        <a href={item.path} target="_blank" rel="noopener noreferrer">
          {getLabel(item.icon, item.label)}
        </a>
      </li>
    );
  }
  return (
    <li>
      <Link
        to={item.path}
        activeOptions={{
          exact: true,
          includeSearch: false,
        }}
        activeProps={{
          className: "active",
        }}
      >
        {getLabel(item.icon, item.label)}
      </Link>
    </li>
  );
};

export default SidebarMenuItems;
